'use strict'

import CommonApi from '@/api/interview.js'
import SpecialApi from '../../api/interview.js'
import { dataURItoBlob } from '@/_helpers/utils.js'

const state = {
  loading: false,
  data: null,
  error: null
}

const actions = {
  fetch ({commit, rootGetters}) {
    commit('request')

    const interview = rootGetters['interview/one']

    return SpecialApi.fetchOneTest(interview.token)
      .then(data => commit('fetchSuccess', data))
      .catch(err => commit('failure', err))
  },

  saveAnswer ({commit, rootGetters}, {question, answer}) {
    commit('request')

    const interview = rootGetters['interview/one']

    return CommonApi.saveTestAnswers(interview.token, question.id, [answer])
      .then(data => commit('answerSuccess', {question, data, answer}))
      .catch(err => commit('failure', err))
  },

  end ({commit, rootGetters}) {
    const interview = rootGetters['interview/one']

    return CommonApi.endTest(interview.token)
  },

  uploadPicturePublic ({rootGetters}, {picture}) {
    const interview = rootGetters['interview/one']
    const blob = dataURItoBlob(picture)
    SpecialApi.uploadPicturePublic(interview.token, {picture: blob})
  }
}

const mutations = {
  request (state) {
    state.error = null
    state.loading = true
  },

  failure (state, err) {
    state.loading = false
    state.error = err
  },

  fetchSuccess (state, data) {
    state.loading = false
    state.data = data
  },

  answerSuccess (state, {question, data, answer}) {
    const answerId = answer.id
    // deselect all answers in question, select only that came from the api call
    question.answers.forEach(answer => { answer.is_chosen = answer.id === answerId })
  }
}

const getters = {
  error (state, getters) {
    return state.error
  },

  one (state, getters) {
    return state.data
  },

  // in miliseconds
  intervalToTakePhotos (state) {
    return 15000
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
